<div class="staff-parameter-block">
    <h3>Parámetros</h3>
    <div class="parameter-item-list">
        <div class="parameter-each file-uploader">
            <mat-label class="upload-label">Fichero</mat-label>
            <div class="upload-wrapper">
                <!--<input type="file" class="file-input" [formControl]="importExcel" #fileUpload accept=".xlsx" (change)="onFileChange($event.target.files)" multiple="false">-->
                <input type="file" class="file-input" [formControl]="importExcel" #fileUpload accept="{{FileFormatEnum.AttributeImportController}}" (change)="onFileChange($event.target.files)" multiple="false">
                <div class="file-upload">
                    <button mat-raised-button color="accent" class="upload-btn" (click)="fileUpload.value='';fileUpload.click()">
                        <mat-icon>cloud_upload</mat-icon>
                    </button>
                </div>
                <span class="no-msg" *ngIf="fileChosen">{{fileChosenName}}</span>
            </div>
        </div>
        
    </div>
    <div class="parameter-item-list">
        <div class="parameter-each width-s">
            <mat-label>Primera fila</mat-label>
            <mat-form-field class="example-full-width">
                <input matInput [formControl]="primeraFila" type="number" value="2" min="1" max="20000">
                <mat-error *ngIf="primeraFila && primeraFila.invalid">
                    <span class="validation-span">Inválido</span>
                  </mat-error>
            </mat-form-field>
        </div>
        <div class="parameter-each width-s">
            <mat-label>Columna clave</mat-label>
            <mat-form-field class="example-full-width">
                <input matInput type="number" [formControl]="columnaClave" value="1"  min="1" max="200">
                <mat-error *ngIf="columnaClave && columnaClave.invalid">
                    <span class="validation-span">Inválido</span>
                  </mat-error>
            </mat-form-field>
        </div>
        <div class="parameter-each width-s p-t-15">
            <mat-checkbox class="example-margin"  [formControl]="eliminarExisitingAttributos">Eliminar atributos existentes</mat-checkbox>      
        </div>
   </div>
</div>